module.exports = __webpack_public_path__ + "img/logo_sm_light.4d1ad084.svg";